<template>
  <div class="page">
    <div class="fixed-top">
      <div class="van-hairline--bottom">
        <van-cell-group>
          <van-cell title="开始时间" :value="startTime" is-link size="large" @click="showDatetimePickerPopup('start')" style="background: #fff;" />
          <van-cell title="结束时间" :value="endTime" is-link size="large" @click="showDatetimePickerPopup('end')" style="background: #fff;" />
        </van-cell-group>
      </div>
    </div>

    <div class="data-box van-hairline--top-bottom">
      <tr class="kf-salary" :class="isOutOrder?'':'kf-salary-order'" style="width: 100vw">
        <th>
          <div class="value">{{summaryData == null ? '0' : isParameter(summaryData.orderCount)}}</div>
          <div class="label">订单数</div>
        </th>
        <th>
          <div class="value"><small>¥ </small>{{summaryData == null ? '0' : formatPrice(summaryData.orderAmount)}}</div>
          <div class="label">订单金额</div>
        </th>
        <th>
          <div class="value"><small>¥ </small>{{summaryData == null ? '0' : formatPrice(summaryData.wagesAmount)}}</div>
          <div class="label">订单工资</div>
        </th>
        <th rowspan="2" style="display:table-cell;vertical-align:middle;padding: 0 8px;border-right: none" v-if="isOutOrder" >
          <div class="value"><small>¥ </small>{{summaryData == null ? '0' : formatPrice(summaryData.totalWages)}}</div>
          <div class="label">总工资</div>
        </th>
      </tr>
      <tr class="kf-salary" v-if="isOutOrder">
        <th>
          <div class="value">{{summaryData == null ? '0' : isParameter(summaryData.outOrderCount)}}</div>
          <div class="label">外部订单数</div>
        </th>
        <th>
          <div class="value"><small>¥ </small>{{summaryData == null ? '0' : formatPrice(summaryData.outOrderTotalAmount)}}</div>
          <div class="label">外部订单金额</div>
        </th>
        <th>
          <div class="value"><small>¥ </small>{{summaryData == null ? '0' : formatPrice(summaryData.outOrderTotalWages)}}</div>
          <div class="label">外部订单工资</div>
        </th>
      </tr>
    </div>

    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="loadData">
      <div class="overflow-slide">
        <table class="table" width="100%" bgcolor="#fff" style="margin-top: 8px;text-align: center;" >
          <tr>
            <th style="background: var(--primary-color)">客服</th>
            <th>订单数</th>
            <th>订单金额</th>
            <th>续单金额</th>
            <th>续单率</th>
            <th>订单工资</th>
            <th v-if="isOutOrder">外部订单数</th>
            <th v-if="isOutOrder">外部订单金额</th>
            <th v-if="isOutOrder">外部订单工资</th>
            <th v-if="isOutOrder">总工资</th>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td>{{item.name}}</td>
            <td>{{item.orderCount!=null?item.orderCount:0}}</td>
            <td><small>¥ </small>{{item.orderAmount!=null?formatPrice(item.orderAmount):0}}</td>
            <td><small>¥ </small>{{item.continuedAmount!=null?formatPrice(item.continuedAmount):0}}</td>
            <td>{{item.continuedPercent  + '%' }}</td>
            <td><small>¥ </small>{{item.wagesAmount?formatPrice(item.wagesAmount):0}}</td>
            <td v-if="isOutOrder">{{item.outOrderCount!=null?item.outOrderCount:0}}</td>
            <td v-if="isOutOrder"><small>¥ </small>{{item.outOrderTotalAmount!=null?formatPrice(item.outOrderTotalAmount):0}}</td>
            <td v-if="isOutOrder"><small>¥ </small>{{item.outOrderKfWages!=null?formatPrice(item.outOrderKfWages):0}}</td>
            <td v-if="isOutOrder"><small>¥ </small>{{formatPrice(item.totalWages)}}</td>
          </tr>
        </table>

      </div>
    </van-list>

    <!-- 选择日期 -->
    <van-popup
        v-model="datetimePickerPopupShow"
        class="datetime-picker-popup"
        position="bottom"
    >
      <van-datetime-picker
          v-model="datetimePicker.value"
          type="date"
          :max-date="datetimePicker.maxDate"
          :formatter="datetimePickerFormatter"
          @confirm="datetimePickerConfirm"
          @cancel="datetimePickerPopupShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Popup,
  Button,
  List,
  CellGroup,
  Cell,
  Row,
  Col,
  DatetimePicker,
  ActionSheet,
  Dialog,
  Toast,
  Collapse, CollapseItem, Field, Picker
} from 'vant';
import { getDefaultTime, getSumAmount, listKfWages } from '@/api/admin/kf-wages'

import moment from 'moment';
import Decimal from 'decimal.js';
Vue.use(Popup)
    .use(Button)
    .use(List)
    .use(CellGroup)
    .use(Cell)
    .use(Row)
    .use(Col)
    .use(DatetimePicker)
    .use(ActionSheet)
    .use(Dialog)
    .use(Toast)
    .use(Collapse)
    .use(CollapseItem)
    .use(Field)
    .use(Picker)

export default {
  name: 'admin-clerk-wages',
  components: {
  },
  data () {
    return {
      datetimePickerPopupShow: false,
      datetimePicker: {
        field: null,
        value: null,
        maxDate: moment().add('1', 'weeks').toDate()
      },
      startTime: null,
      endTime: null,
        summaryData: null,
      list: [],
      loading: true,
      listFinished: false,
      pageNo: 1,
      pageSize: 30
    }
  },
  computed: {
    isOutOrder(){
      return this.$hasFeature('out_order')
    }
  },
  methods: {
    datetimePickerFormatter(field, value) {
      if (field === 'year') {
        return `${value}年`;
      } else if (field === 'month') {
        return `${value}月`
      } else if (field == 'day') {
        return `${value}日`
      }
      return value;
    },
    showDatetimePickerPopup(field) {
      this.datetimePicker.field = field
      if (field == 'start') {
        this.datetimePicker.value = moment(this.startTime).toDate()
      } else if (field == 'end') {
        this.datetimePicker.value = moment(this.endTime).toDate()
      }
      this.datetimePickerPopupShow = true;
    },
    datetimePickerConfirm(value) {
      this.datetimePickerPopupShow = false;
      if (this.datetimePicker.field == 'start') {
        this.startTime = moment(value).format('YYYY-MM-DD');
      } else if (this.datetimePicker.field == 'end') {
        this.endTime = moment(value).format('YYYY-MM-DD');
      }
      this.getSumAmount();
      this.loadData(true);
    },
    isParameter(parameter) {
      if (parameter != null) {
        return parameter
      }
      return '0'
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return '0'
    },
    getDefaultTime() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getDefaultTime().then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.startTime = moment(data.startTime).format('YYYY-MM-DD')
          this.endTime = moment(data.endTime).format('YYYY-MM-DD')

          this.getSumAmount()
          this.loadData(true)
        } else {
          Dialog.alert({
            title: '加载默认时间失败',
            message: data.msg
          })
        }
      })
    },
    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      listKfWages(this.startTime, this.endTime, this.pageNo, this.pageSize).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          const list =  data.list
          for (const item of list) {
            const orderCount = item.orderCount;
            const continuedCount = item.continuedCount;
            let continuedPercent = 0;
            if (orderCount != null && continuedCount != null) {
              continuedPercent = Decimal.mul(Decimal.div(continuedCount, orderCount), 100).toFixed(2);
            }
            item.continuedPercent = continuedPercent
          }
          this.list = this.list.concat(list)
          if (data.hasNextPage) {
            this.listFinished = true
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo ++
      })
    },
    getSumAmount() {
      this.summaryData = null;
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getSumAmount(this.startTime, this.endTime).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.summaryData = data.summaryData;
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    }
  },
  mounted() {
    this.getDefaultTime()
  }
}
</script>

<style lang="less" scoped>

.page {
  .fixed-top {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: #fff;
  }

  .data-box {
    background: #fff;
    .item {
      padding: 15px 5px;
      text-align: center;
      .value {
        color: #ff6600;
        font-size: 18px;
      }
      .label {
        color: #666;
        font-size: 14px;
        margin-top: 6px;
      }
    }
  }
}

.table {
  border-collapse: separate;
  border-spacing:0;

  th, td {
    width: 100%;
    font-weight: normal;
    padding: 8px 5px;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
  }
  th {
    color: #fff;
    background: var(--primary-color);
  }
  td {
    color: #666;
  }

  td:first-child, th:first-child {
    position:sticky;
    left:0; /* 首行在左 */
    z-index:10;
    background-color: #FFFFFF;
    -webkit-box-shadow:1px 2px 6px 0px #e9e9e9;
    border-right: 0px;
  }

  th:first-child{
    z-index:2;
  }
}
.kf-salary{
  th {
    padding: 15px 5px;
    text-align: center;
    width: 20%;
    border-right: 1px solid #eaecef;
    border-bottom: 1px solid #eaecef;
  }
  .value {
    color: #ff6600;
    font-size: 18px;
  }
  .label {
    color: #666;
    font-size: 14px;
    margin-top: 6px;
    font-weight: 400;
  }
  td {
    color: #666;
  }
}
.kf-salary-order{
  th {
    padding: 15px 5px;
    text-align: center;
    width: 33.3vw;
  }
}


.overflow-slide{
  overflow-x: auto;
  white-space: nowrap;
  justify-content: space-evenly;
}


</style>
